import styled, { css } from 'styled-components';
import { themed } from '@/shared/ui/core';

export const RateContainer = styled.div.attrs({
  className: 'RateContainer',
})`
  margin-bottom: 1rem;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
`;

export const RadioStar = styled.input.attrs({
  className: 'RadioStar',
  type: 'radio',
})`
  ${themed('visuallyHidden')}
`;

export const RadioStarLabel = styled.label.attrs({
  className: 'radioStarLabel',
})`
  cursor: pointer;

  &:last-child {
    margin-left: 0;
  }

  &:first-child {
    margin-left: .8rem;
  }

  & + label {
    margin-left: .8rem;
  }

  svg path {
    fill: ${({ $shouldFill }) => $shouldFill && themed('primary.main')};
    stroke: ${themed('primary.darkGray')};
  }

  ${({ $disabled }) => !$disabled && css`
    &:hover,
    &:hover ~ & {
      transform: scale(1.2,1.2);
      path {
        fill: ${themed('primary.accent')};
      }
    }
  `}
`;
